/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Metrics1AnyOfValue
 */
export interface Metrics1AnyOfValue {
}

/**
 * Check if a given object implements the Metrics1AnyOfValue interface.
 */
export function instanceOfMetrics1AnyOfValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Metrics1AnyOfValueFromJSON(json: any): Metrics1AnyOfValue {
    return Metrics1AnyOfValueFromJSONTyped(json, false);
}

export function Metrics1AnyOfValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): Metrics1AnyOfValue {
    return json;
}

export function Metrics1AnyOfValueToJSON(value?: Metrics1AnyOfValue | null): any {
    return value;
}

